// extracted by mini-css-extract-plugin
export default {"modal":"oMMyVltMOjeq6s5YT6Fw","quotaName":"QhWQdTEu_YdlAL9590ix"};